const EDGE_LENGTH = 5;

export const truncateFilename = (filename: string): string => {
  if (filename === "") {
    return "";
  }
  const filenameStr = String(filename);

  if (filenameStr.length <= EDGE_LENGTH + EDGE_LENGTH) {
    return filenameStr;
  }
  return `${filenameStr.slice(0, EDGE_LENGTH)}...${filenameStr.slice(-EDGE_LENGTH)}`;
};
